"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _reduxObservable = require("redux-observable");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _epics = _interopRequireDefault(require("settings-ui-sdk/Products/epics"));

var _epics2 = _interopRequireDefault(require("settings-ui-sdk/Folders/epics"));

var _epics3 = _interopRequireDefault(require("settings-ui-sdk/QuoteAutomation/epics"));

var _epics4 = _interopRequireDefault(require("settings-ui-sdk/QuoteApproval/epics"));

var _epics5 = _interopRequireDefault(require("settings-ui-sdk/Quotes/epics"));

var _rootReducer = _interopRequireDefault(require("./rootReducer"));

var _AsyncProductsQuotesContainer = _interopRequireDefault(require("./containers/AsyncProductsQuotesContainer"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _products = require("./constants/products");

var _default = {
  route: _UrlPathParams.PRODUCTS,
  routes: _react.default.createElement(_reactRouter.Route, {
    path: _UrlPathParams.PRODUCTS,
    component: _AsyncProductsQuotesContainer.default
  }, _react.default.createElement(_reactRouter.Route, {
    path: _products.QUOTES_ROUTE
  })),
  reducer: _rootReducer.default,
  rootEpic: (0, _reduxObservable.combineEpics)(_epics2.default, _epics.default, _epics3.default, _epics4.default, _epics5.default),
  shouldModuleRender: (0, _scopeChecks.matchesAllScopes)(['sales-settings-access'])
};
exports.default = _default;
module.exports = exports.default;